import { Map, fromJS, toJS } from 'immutable';
import {
  SET_PROJECT,
  SET_PROJECT_UNDOABLE,
  REMOVE_PROJECT_IMAGE,
} from './project';
import {
  IMAGE_ADDED,
  IMAGE_REMOVED,
} from '../sagas/ReturnedChangesetProcessor';

/**
 *  action constants
 */

export const ADD_IMAGE_TAG = 'ADD_IMAGE_TAG';
const REMOVE_IMAGE_TAG = 'REMOVE_IMAGE_TAG';
const UPDATE_IMAGE_META = 'UPDATE_IMAGE_META';

function removeSubKey(map, keyToRemove) {
  return map.map((value) => {
    if (Map.isMap(value)) {
      return value.filter((_, key) => key !== keyToRemove);
    }
    return value;
  });
}

/**
 *  reducers
 */
const reducer = function images(state = new Map(), action) {
  // Image usage data is now handled via another reducer so we remove it from the image objects.

  switch (action.type) {
    case SET_PROJECT_UNDOABLE:
    case SET_PROJECT:
      let newMap =
        action.project.images != undefined
          ? new Map(fromJS(action.project.images))
          : new Map();
      newMap = removeSubKey(newMap, 'usage');
      return state.merge(newMap);
    case IMAGE_ADDED:
      let imageMap = fromJS(action.image);
      imageMap = imageMap.delete('usage');
      return state.set(action.image.imageID, imageMap);
    case REMOVE_PROJECT_IMAGE:
      let removedState = state;
      if (Array.isArray(action.image)) {
        action.image.forEach((id) => {
          removedState = removedState.delete(id);
        });
      } else {
        removedState = state.delete(action.image);
      }

      return removedState;
    case IMAGE_REMOVED:
      return state.delete(action.image);
    case ADD_IMAGE_TAG:
      let newState = state.updateIn([action.imageID, 'tags'], (tags) => {
        return tags ? tags.push(action.tag) : [action.tag];
      });

      return newState;
    case REMOVE_IMAGE_TAG:
      let removeNewState = state.updateIn([action.imageID, 'tags'], (tags) => {
        return tags.filter((tag) => tag != action.tag);
      });
      return removeNewState;
    case UPDATE_IMAGE_META:
      return state.setIn([action.imageID, 'notes'], action.notes);
  }

  return state;
};

export default {
  reducer: reducer,
};

/**
 *  actions
 */

export function removeImageTag(imageID, tag) {
  return {
    type: REMOVE_IMAGE_TAG,
    imageID,
    tag,
  };
}

export function addImageTag(imageID, tag) {
  return {
    type: ADD_IMAGE_TAG,
    imageID,
    tag,
  };
}

export function updateImageMeta(imageID, notes) {
  return {
    type: UPDATE_IMAGE_META,
    imageID,
    notes,
  };
}

/**
 * Sagas
 */
